const changePicturesLikesCountsLocally = (picturesLikesCounts, setPicturesLikesCounts, id, actionTaken) => {
  const updatedPicturesLikesCounts = Object.assign({}, picturesLikesCounts);
  switch (actionTaken) {
    case 'like':
      updatedPicturesLikesCounts[id] += 1;
      break;
    case 'unlike':
      updatedPicturesLikesCounts[id] -= 1;
      break;
    default:
      break;
  }

  setPicturesLikesCounts(updatedPicturesLikesCounts);
};

export default changePicturesLikesCountsLocally;
